import createTableStore from "ds/components/Table/store/useTableStore";

import { SPACE_CONTEXTS_COLUMN_CONFIG, SPACE_CONTEXTS_COLUMNS_STORAGE_KEY } from "./constants";

const useSpaceDetailsContextsTableStore = createTableStore({
  storageKey: SPACE_CONTEXTS_COLUMNS_STORAGE_KEY,
  config: SPACE_CONTEXTS_COLUMN_CONFIG,
});

export default useSpaceDetailsContextsTableStore;
